import { send } from 'server';

export const confirmSingleBetLimit = (action) => send({
    ID: 35799,
    responses: [35800, 35801],
    description: 'Accept Player RG Limits',
    action,
    timePeriods: [],
    limitType: 'singleBet'
});
